module.exports = __webpack_public_path__ + "img/slide5.7b027d2b.jpg";